<form
  class="invite-field"
  [formGroup]="form"
  [class.focused]="focused"
  [class.textarea-style]="textareaStyle"
  autocomplete="off"
>
  <div class="email-area">
    @for (email of emails; track email; let i = $index) {
    <div class="email" [class.invalid]="isInvalid(email, i)" [appTooltip]="getError(email, i)">
      <span>{{ email }}</span>
      <button
        appButton
        type="button"
        name="remove-email"
        location="emais-entry-field"
        (click)="removeEmail(i)"
        height="-2"
        [iconButton]="true"
        [color]="isInvalid(email, i) ? 'simple-warn' : 'simple'"
      >
        <app-svg src="/assets/icons/16/cross.svg"></app-svg>
      </button>
    </div>
    }
    <input
      type="email"
      formControlName="emails"
      (keypress)="onKeyPress($event)"
      (keydown)="onKeyDown($event)"
      [placeholder]="emails.length ? '' : 'Enter email(s)...'"
      data-test-id="emails-input"
      (paste)="parseEmails()"
      enterkeyhint="next"
      (focus)="focused = true"
      (focus)="focus()"
      (blur)="blur()"
      id="input-emails"
      autocomplete="off"
      data-1p-ignore="true"
      data-lpignore="true"
    />
    <label for="input-emails"></label>
  </div>
  <ng-content></ng-content>
</form>
